import { Box, Typography } from '@mui/material';
import { Dialog } from 'components/commons';
import ja from 'utils/ja';

interface ConfirmDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  handleConfirm: () => void;
}

const ConfirmDeleteDialog = ({
  open,
  onClose,
  handleConfirm,
}: ConfirmDeleteDialogProps) => {
  return (
    <Dialog
      open={open}
      handleClose={onClose}
      title={ja.user_detail.dialog.title}
      handleConfirm={handleConfirm}
    >
      <Box
        sx={{
          width: { xs: '80vw', sm: '638px' },
          padding: '10px',
        }}
      >
        <Typography
          sx={{
            fontSize: '20px !important',
            fontWeight: '400',
            textAlign: 'center',
          }}
        >
          {ja.user_detail.dialog.content}
        </Typography>
      </Box>
    </Dialog>
  );
};
export default ConfirmDeleteDialog;
